interface TypographyProps {
    children: React.ReactNode;
    className?: string;
}

export const BodyMedium = ({ children, className = '' }: TypographyProps) => {
    return (
        <p className={`font-outfit text-base font-medium leading-6 ${className}`}>
            {children}
        </p>
    );
};